export const TRANSIT_DAYS_KEY = 'ym_transit_days'
export const ORDER_FIELDS_KEY = 'ym_order_fields'
export const SENT_KEY = 'ym_sent_messages'
export const CHAT_IDS_KEY = 'ym_chat_ids'

export type MsgType = 'firstMsg' | 'confirmMsg' | 'courierMsg'

export interface SavedOrderFields {
  shipDate?: string
  shipTime?: string
  transitDays?: string
  track?: string
  greetingPartIndex?: string
}

export interface SentEntry {
  sentAt: string
  chatId: number
}

export function loadTransitDays(): Record<string, string> {
  try { return JSON.parse(localStorage.getItem(TRANSIT_DAYS_KEY) || '{}') }
  catch { return {} }
}

export function saveTransitDaysForCity(city: string, days: string) {
  const map = loadTransitDays()
  if (days) map[city] = days
  else delete map[city]
  localStorage.setItem(TRANSIT_DAYS_KEY, JSON.stringify(map))
}

export function loadOrderFields(orderId: number): SavedOrderFields | null {
  try {
    const all = JSON.parse(localStorage.getItem(ORDER_FIELDS_KEY) || '{}')
    return all[orderId] || null
  } catch { return null }
}

export function saveOrderField(orderId: number, key: keyof SavedOrderFields, value: string) {
  try {
    const all = JSON.parse(localStorage.getItem(ORDER_FIELDS_KEY) || '{}')
    if (!all[orderId]) all[orderId] = {}
    all[orderId][key] = value
    localStorage.setItem(ORDER_FIELDS_KEY, JSON.stringify(all))
  } catch {}
}

export function saveSent(orderId: number, type: MsgType, entry: SentEntry) {
  try {
    const all = JSON.parse(localStorage.getItem(SENT_KEY) || '{}')
    if (!all[orderId]) all[orderId] = {}
    all[orderId][type] = entry
    localStorage.setItem(SENT_KEY, JSON.stringify(all))
  } catch {}
}

export function loadChatId(orderId: number): number | undefined {
  try {
    const all = JSON.parse(localStorage.getItem(CHAT_IDS_KEY) || '{}')
    return all[orderId]
  } catch { return undefined }
}

export function saveChatId(orderId: number, chatId: number) {
  try {
    const all = JSON.parse(localStorage.getItem(CHAT_IDS_KEY) || '{}')
    all[orderId] = chatId
    localStorage.setItem(CHAT_IDS_KEY, JSON.stringify(all))
  } catch {}
}

export function formatSentAt(iso: string): string {
  return new Date(iso).toLocaleString('ru-RU', {
    day: '2-digit', month: '2-digit', hour: '2-digit', minute: '2-digit',
  })
}
